<template>
  <div
    class="absolute z-10 top-0 bottom-0 left-0 h-full"
    :class="sidebarWidthClass"
  >
    <div class="absolute top-0 -right-1 sm:-right-4 bottom-0 z-10 py-2 sm:py-4 flex flex-col gap-3 justify-start items-center w-8 h-full">
      <button
        @click="centerOfMap()"
        class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
        type="button"
        title="Center Of Map">
        <i class="material-icons text-sm text-white font-bold">center_focus_weak</i>
      </button>
      <button
        @click="toZoomIn()"
        class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
        type="button"
        title="Zoom In">
        <i class="material-icons text-sm text-white font-bold">add</i>
      </button>
      <button
        @click="toZoomOut()"
        class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
        type="button"
        title="Zoom Out">
        <i class="material-icons text-sm text-white font-bold">remove</i>
      </button>
      <button
        v-if="sidebarControl.opacity !== '0'"
        @click="toHideSidebar()"
        class="flex justify-center items-center w-8 h-8 bg-red-300 rounded-md border border-white"
        type="button"
        title="Sembunyikan Sidebar Kiri">
        <i class="material-icons text-sm text-white font-bold">close</i>
      </button>
      <button
        v-if="sidebarControl.opacity === '0' && (mapControl.mode === 'history' || mapControl.mode === 'plotting')"
        @click="toShowSidebar()"
        class="flex justify-center items-center w-8 h-8 bg-gray-500 rounded-md border border-white"
        type="button"
        title="Informasi Kapal">
        <i class="material-icons text-sm text-white font-bold">info</i>
      </button>
      <span
        v-if="mapControl.inload"
        class="flex justify-center items-center w-8 h-8"
        title="Status Load Map (loading)">
        <i class="material-icons text-sm text-white font-bold animate-spin">autorenew</i>
      </span>
      <span
        v-if="mapControl.completeload && sidebarControl.opacity === '0'"
        class="flex justify-center items-center w-8 h-8 bg-green-500 rounded-md"
        title="Status Load Map (selesai)">
        <i class="material-icons text-sm text-white font-bold">published_with_changes</i>
      </span>
    </div>
    <div
      class="`absolute top-0 bottom-0 left-0 right-0 z-0 w-full h-full bg-gray-500 rounded-tr-xl rounded-br-xl"
      :class="sidebarOpacityClass"
    >
      <slot v-if="sidebarControl.opacity !== '0'"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Sidebar',
  computed: {
    ...mapGetters([
      'sidebarControl',
      'mapControl'
    ]),
    sidebarWidthClass () {
      return `w-${this.sidebarControl.width}`
    },
    sidebarOpacityClass () {
      return `opacity-${this.sidebarControl.opacity}`
    }
  },
  methods: {
    ...mapActions([
      'toZoom',
      'toZoomIn',
      'toZoomOut',
      'toHideSidebar',
      'toShowSidebar'
    ]),
    centerOfMap: function () {
      this.toZoom({
        view: [-1.9332268264771106, 113.2470703125],
        zoom: 5
      })
    }
  }
}
</script>
